import {Button, Result} from "antd";
import React from "react";
import {t} from "i18next";

const Error404 = () => {

    return (
        <Result
            status="404"
            title="404"
            subTitle= {t("common.title404")}
            extra={
                <Button type="primary">
                    <a href="/personnel">{t("common.backHome")}</a>
                </Button>
            }
        />
    );
};

export default Error404;
